import { render, staticRenderFns } from "./therapyDetail.vue?vue&type=template&id=e596dfd2&scoped=true&"
import script from "./therapyDetail.vue?vue&type=script&lang=js&"
export * from "./therapyDetail.vue?vue&type=script&lang=js&"
import style0 from "./therapyDetail.vue?vue&type=style&index=0&id=e596dfd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e596dfd2",
  null
  
)

export default component.exports